export const huLang = {
  Play: 'Lejátszás',
  Pause: 'Szünet',
  'Current Time': 'Aktuális időpont',
  Duration: 'Hossz',
  'Remaining Time': 'Hátralévő idő',
  'Stream Type': 'Adatfolyam típusa',
  LIVE: 'ÉLŐ',
  Loaded: 'Betöltve',
  Progress: 'Állapot',
  Fullscreen: 'Teljes képernyő',
  'Non-Fullscreen': 'Normál méret',
  Mute: 'Némítás',
  Unmute: 'Némítás kikapcsolva',
  'Playback Rate': 'Lejátszási sebesség',
  Subtitles: 'Feliratok',
  'subtitles off': 'Feliratok kikapcsolása',
  Captions: 'Magyarázó szöveg',
  'captions off': 'Magyarázó szöveg kikapcsolva',
  Chapters: 'Fejezetek',
  'You aborted the media playback': 'Leállította a lejátszást',
  'A network error caused the media download to fail part-way.': 'Hálózati hiba miatt a videó részlegesen töltődött le.',
  'The media could not be loaded, either because the server or network failed or because the format is not supported.': 'A videó nem tölthető be hálózati vagy kiszolgálói hiba miatt, vagy a formátuma nem támogatott.',
  'The media playback was aborted due to a corruption problem or because the media used features your browser did not support.': 'A lejátszás adatsérülés miatt leállt, vagy a videó egyes tulajdonságait a böngészője nem támogatja.',
  'No compatible source was found for this media.': 'Nincs kompatibilis forrás ehhez a videóhoz.',
  'The media is encrypted and we do not have the keys to decrypt it.': 'The media is encrypted and we do not have the keys to decrypt it.',
  'Play Video': 'Videó lejátszása',
  Close: 'Bezár',
  'Close Modal Dialog': 'Ablak bezárása',
  'Modal Window': 'Ablak',
  'This is a modal window': 'Ez az ablak',
  'This modal can be closed by pressing the Escape key or activating the close button.': 'Ez az ablak az ESC billentyűvel zárható.',
  ', opens captions settings dialog': ', opens captions settings dialog',
  ', opens subtitles settings dialog': ', opens subtitles settings dialog',
  ', opens descriptions settings dialog': ', opens descriptions settings dialog',
  ', selected': 'kiválasztva',
  'captions settings': 'Feliat beállítása',
  'subtitles settings': 'Feliat beállítása',
  'descriptions settings': 'Leíás beállítása',
  Text: 'Szöveg',
  White: 'Fehér',
  Black: 'Fekete',
  Red: 'Piros',
  Green: 'Zöld',
  Blue: 'Kék',
  Yellow: 'Sárga',
  Magenta: 'Magenta',
  Cyan: 'Cián',
  Background: 'Háttér',
  Window: 'Ablak',
  Transparent: 'Átlátszó',
  'Semi-Transparent': 'Félig átlátszó',
  Opaque: 'Áttetsző',
  'Font Size': 'Betűméret',
  'Text Edge Style': 'Szöveg körvonalámak sítlusa',
  None: 'Nincs',
  Raised: 'Kiemelt',
  Depressed: 'Nyomott',
  Uniform: 'Egységes',
  Dropshadow: 'Árnyékot vet',
  'Font Family': 'Betűkészlet',
  'Proportional Sans-Serif': 'Proportional Sans-Serif',
  'Monospace Sans-Serif': 'Monospace Sans-Serif',
  'Proportional Serif': 'Proportional Serif',
  'Monospace Serif': 'Monospace Serif',
  Casual: 'Casual',
  Script: 'Szkript',
  'Small Caps': 'Kis Kapitáls',
  Reset: 'Visszaállítás',
  'restore all settings to the default values': 'Eredeti értékek visszaállítása',
  Done: 'Kész',
  'Caption Settings Dialog': 'Felirat beállításai',
  'Beginning of dialog window. Escape will cancel and close the window.': 'A beállítások kezdése. Az ESC lenyomása bezárja az ablakot.',
  'End of dialog window.': 'A beállítás bezárása',
  '{1} is loading.': '{1} töltése.',
  'Exit Picture-in-Picture': 'Kép a képben bezárása',
  'Picture-in-Picture': 'Kép a képben'
};
